var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active-creat"},[_c('div',{staticClass:"active-title"},[_vm._v("活动创建")]),_c('creatandEdit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }